<template>
    <div class="search-filter-summary">
        <p v-if="!items.length" class="mb-0 grey--text">Без дополнительных фильтров</p>
        <p v-for="(item, index) in items" :key="index" class="mb-1">
            <strong>{{ item.label }}:</strong> {{ item.value }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'SearchFilterSummary',
    props: {items: {type: Array, default: () => []}},
}
</script>

<style scoped>
.search-filter-summary {
    overflow-wrap: anywhere;
    white-space: pre-wrap;
}
</style>
